import React from 'react'
import { Typography, Grid, Box, Card, Button, Divider } from '@material-ui/core'
import { useTheme } from '@material-ui/core/styles'
import { useHistory } from 'react-router-dom'
import ArrowBackIos from '@material-ui/icons/ArrowBackIos'
import emergencyInfoStyles from '../emergencyInfoStyles'
import IconPicker from '../../apps/AppComponents/IconPicker/IconPicker'

function EmergencyInformation() {
  const classes = emergencyInfoStyles()
  const theme = useTheme()

  const history = useHistory()

  const eapBodyContent = (
    <>
      <Typography variant="body1">
        During an emergency, proper action saves lives. For your safety, please
        familiarize yourself with the basic steps outlined in the Emergency
        Action Plan which pertain to students, faculty and staff at all Rutgers
        University locations.
      </Typography>
      <Divider className={classes.divider} />
      <Typography variant="body1">
        If you are experiencing a medical emergency: Dial{' '}
        <a href="tel:911">911</a> or call the Rutgers University Police
        Department (RUPD) at <a href="tel:732-932-7211">732-932-7211</a>.
        Rutgers Student Health (RSH) is not an emergency medical center.
      </Typography>
    </>
  )

  const erBodyContent = (
    <>
      <Typography variant="h5" className={classes.subheader}>
        After-Hours Care
      </Typography>
      <Typography variant="body1">
        For after-hours or emergency medical care, please contact one of the
        local hospitals or one of the services below. If you have an emergency
        in need of immediate attention, call <a href="tel:911">911</a>.
      </Typography>
      <Divider className={classes.divider} />
      <Typography variant="h5" className={classes.subheader}>
        Reporting Guidelines
      </Typography>
      <Typography variant="body1">
        Immediately report emergency situations occurring in or near your
        facility (such as fire, explosion, storm damage, hazardous material
        spills, chemical odors, flooding, accidents, injuries, criminal or
        suspicious activities, etc.) to the RUPD Communication Center or by
        using a campus emergency telephone.
        <ul>
          <li>
            <Typography variant="body1">
              Location of emergency (you should also indicate that you are at
              Rutgers University as part of your location)
            </Typography>
          </li>
          <li>
            <Typography variant="body1">Nature of the emergency</Typography>
          </li>
          <li>
            <Typography variant="body1">
              Status of the emergency condition (i.e., in progress or completed)
            </Typography>
          </li>
          <li>
            <Typography variant="body1">
              Any immediate threat(s) to life
            </Typography>
          </li>
          <li>
            <Typography variant="body1">
              Need for medical or other assistance
            </Typography>
          </li>
          <li>
            <Typography variant="body1">
              Description, location or direction of travel of suspect(s),
              description of motor vehicle(s) involved, presence of weapons
            </Typography>
          </li>
          <li>
            <Typography variant="body1">
              Any danger to emergency responders
            </Typography>
          </li>
          <li>
            <Typography variant="body1">
              Other information that would aid the emergency response
            </Typography>
          </li>
        </ul>
      </Typography>
    </>
  )

  const necBodyContent = (
    <>
      <Typography variant="body1">
        If you need to contact RUPD Communications Center regarding a
        non-emergency, please select a location to view the relevant
        information:
      </Typography>
      <ul>
        <li>
          <Typography variant="body1">
            New Brunswick/Piscataway
            <a href="tel:(732)-932-7211"> (732)-932-7211</a>
          </Typography>
        </li>
        <li>
          <Typography variant="body1">
            Newark
            <a href="tel:(973)-972-4491"> (973) 972-4491</a> or
            <a href="tel:(973) 353-5111"> (973) 353-5111</a>
          </Typography>
        </li>
        <li>
          <Typography variant="body1">
            Camden
            <a href="tel:(856) 225-6111"> (856) 225-6111</a>
          </Typography>
        </li>
        <li>
          <Typography variant="body1">
            Other Facilities <a href="tel:(732) 932-7211"> (732) 932-7211</a>
          </Typography>
        </li>
      </ul>
    </>
  )

  const ohcBodyContent = (
    <>
      <Typography variant="h5" className={classes.subheader}>
        Mental Health Emergencies
      </Typography>
      <Typography variant="body1">
        If Counseling, Alcohol & Other Drug Assistance Program (CAPS) is closed,
        or you are experiencing a mental health emergency, please use one of the
        following resources:
      </Typography>
      <ul>
        <li>
          <Typography variant="body1">
            ProtoCall, a phone-based service for students in crisis when CAPS is
            closed. Call the main CAPS number,
            <a href="tel:848-932-7884"> 848-932-7884</a>, and follow the
            prompts. After 5:00 pm and on Weekends: Call the 24 hour emergency
            hotline at <a href="tel:732-235-5700">732-235-5700</a> which is
            professionally staffed by the local community mental health center.
          </Typography>
        </li>
        <li>
          <Typography variant="body1">
            Acute Psychiatric Service (APS):
            <a href="tel:855-515-5700"> 855-515-5700</a> , a 24-hour emergency
            service for local residents. If you live outside of Middlesex County
            you should contact the nearest hospital emergency department.
          </Typography>
        </li>
        <li>
          <Typography variant="body1">
            988 Suicide and Crisis Lifeline: Call <a href="tel:988">988</a> or
            Text HELLO to <a href="sms:+988?&amp;body=HELLO">988</a>
          </Typography>
        </li>
        <li>
          <Typography variant="body1">
            NJ Hope Line (Suicide Prevention):
            <a href="tel:855-654-6735"> 855-654-6735</a>
          </Typography>
        </li>
        <li>
          <Typography variant="body1">
            National Crisis Text Line: Text HELLO to{' '}
            <a href="sms:+741741?&amp;body=HELLO">741741</a>.
          </Typography>
        </li>
      </ul>
      <Divider className={classes.divider} />
      <Typography variant="h5" className={classes.subheader}>
        RSH Advice Nurse Line
      </Typography>
      <Typography variant="body1" className={classes.bodyTextSpacing}>
        Phone: <a href="tel:800-890-5882">800-890-5882</a>
      </Typography>
      <Typography variant="body1" className={classes.bodyTextSpacing}>
        This free service is provided for non-urgent medical problems that arise
        when our Health Centers are closed. It provides Rutgers students with
        access to experienced registered nurses who can answer health-related
        questions and help students decide the best course of action to take.
      </Typography>
      <Typography variant="body1" className={classes.bodyTextSpacing}>
        The RSH Advice Nurse Line is produced by CitraHealth using standardized
        procedures and nationally recognized Clinical Triage Protocols. RSH
        reviews the calls for quality assurance and to assist students with
        appropriate follow-up.
      </Typography>
      <Divider className={classes.divider} />
      <Typography variant="h5" className={classes.subheader}>
        Hospitals
      </Typography>
      <Button
        variant="contained"
        className={classes.hospitalButton}
        href="tel:732-828-3000"
      >
        <Typography variant="h5">
          Robert Wood Johnson University Hospital
        </Typography>
        <Typography variant="body1" className={classes.phoneBox}>
          Phone: <span className={classes.phoneWithoutLink}>732-828-3000</span>
        </Typography>
      </Button>
      <Button
        variant="contained"
        className={classes.hospitalButton}
        href="tel:732-745-8600"
      >
        <Typography variant="h5">
          St. Peter&rsquo;s University Hospital
        </Typography>
        <Typography variant="body1" className={classes.phoneBox}>
          Phone: <span className={classes.phoneWithoutLink}>732-745-8600</span>
        </Typography>
      </Button>
    </>
  )

  const categories = [
    {
      name: 'Emergency Action Plan',
      icon: 'fa-solid fa-list-check',
      link: 'https://ipo.rutgers.edu/publicsafety/eap',
      body: eapBodyContent,
    },
    {
      name: 'Emergency Reporting',
      icon: 'fa-solid fa-phone-volume',
      link: 'https://ipo.rutgers.edu/publicsafety/eap',
      body: erBodyContent,
    },
    {
      name: 'Non-Emergency Contacts',
      icon: 'fa-solid fa-address-book',
      link: 'https://ipo.rutgers.edu/publicsafety/eap',
      body: necBodyContent,
    },
    {
      name: 'Other Help Contacts',
      icon: 'fa-solid fa-hand-holding-medical',
      link: 'https://ipo.rutgers.edu/publicsafety/eap',
      body: ohcBodyContent,
    },
  ]

  const moreInfo = [
    {
      name: 'Medical Emergency',
      icon: 'fa-solid fa-truck-medical',
      link: 'https://ipo.rutgers.edu/publicsafety/eap/medical-emergency',
    },
    {
      name: 'Weather Emergency',
      icon: 'fa-solid fa-cloud-bolt',
      link: 'https://ipo.rutgers.edu/publicsafety/eap/weather-emergency',
    },
    {
      name: 'Fire Emergency',
      icon: 'fa-solid fa-house-fire',
      link: 'https://ipo.rutgers.edu/publicsafety/eap/fire-emergency',
    },
    {
      name: 'Police Emergency',
      icon: 'fa-solid fa-building-shield',
      link: 'https://ipo.rutgers.edu/publicsafety/eap/police-emergency',
    },
  ]

  const handleClick = (name) => {
    const targetElement = document.getElementById(name)
    const yOffset = -72 // Adjust this value to control the vertical offset
    const y =
      targetElement.getBoundingClientRect().top + window.pageYOffset + yOffset
    if (y) {
      window.scrollTo({
        top: y,
        behavior: 'smooth',
      })
    }
  }
  const handleMoreInfoClick = (link) => {
    window.open(link, '_blank')
  }
  return (
    <Box className={classes.centerPage}>
      <Grid
        container
        direction="column"
        alignItems="center"
        className={classes.container}
        wrap="nowrap"
      >
        <Grid
          item
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          className={classes.sectionTitle}
        >
          <Button onClick={() => history.push('/settings')} aria-label="Back">
            <ArrowBackIos />
            <Typography variant="h1" className={classes.backButtonText}>
              Emergency Information
            </Typography>
          </Button>
        </Grid>
        {/* MAIN MENU */}
        <Grid item className={classes.fullWidth}>
          <Card raised className={classes.singleCard}>
            <Grid
              container
              direction="column"
              alignItems="center"
              justifyContent="center"
            >
              <Grid item xs={12} className={classes.cardHeader}>
                <Typography variant="h4">Main Menu</Typography>
              </Grid>
              <Grid
                item
                container
                direction="row"
                justifyContent="center"
                alignItems="stretch"
                className={classes.mainMenuCardContent}
              >
                {categories.map((category) => (
                  <Grid
                    item
                    className={classes.bigBlueButtonGrid}
                    index={category.name}
                  >
                    <Button
                      className={classes.bigBlueButton}
                      onClick={() => handleClick(category.name)}
                    >
                      <IconPicker
                        iconName={category.icon}
                        size="5x"
                        color={theme.color.white}
                      />
                      <Typography
                        variant="h6"
                        className={classes.blueButtonText}
                      >
                        {category.name}
                      </Typography>
                    </Button>
                  </Grid>
                ))}
              </Grid>
            </Grid>
          </Card>
        </Grid>
        {/* FOUR CATEGORIES MAPPED */}
        {categories.map((category) => (
          <Grid
            item
            className={classes.fullWidth}
            index={category.name}
            id={category.name}
          >
            <Card raised className={classes.singleCard}>
              <Grid
                container
                direction="column"
                alignItems="center"
                justifyContent="center"
              >
                <Grid item xs={12} className={classes.cardHeader}>
                  <Typography variant="h4">{category.name}</Typography>
                </Grid>
                <Grid item xs={12} className={classes.iconGrid}>
                  <IconPicker
                    iconName={category.icon}
                    size="5x"
                    color={theme.palette.components.emergencyIcons}
                  />
                </Grid>
                <Grid xs={12} className={classes.cardContent}>
                  {category.body}
                </Grid>
              </Grid>
            </Card>
          </Grid>
        ))}
        {/* MORE INFORMATION */}
        <Grid item className={classes.fullWidth}>
          <Card raised className={classes.singleCard}>
            <Grid
              container
              direction="column"
              alignItems="center"
              justifyContent="center"
            >
              <Grid item xs={12} className={classes.cardHeader}>
                <Typography variant="h4">More Information</Typography>
              </Grid>
              <Grid
                item
                container
                direction="row"
                justifyContent="center"
                alignItems="stretch"
                className={classes.mainMenuCardContent}
              >
                {moreInfo.map((item) => (
                  <Grid
                    item
                    className={classes.bigBlueButtonGrid}
                    index={item.name}
                  >
                    <Button
                      className={classes.bigBlueButton}
                      onClick={() => handleMoreInfoClick(item.link)}
                    >
                      <IconPicker
                        iconName={item.icon}
                        size="5x"
                        color={theme.color.white}
                      />
                      <Typography
                        variant="h6"
                        className={classes.blueButtonText}
                      >
                        {item.name}
                      </Typography>
                    </Button>
                  </Grid>
                ))}
              </Grid>
            </Grid>
          </Card>
        </Grid>
      </Grid>
    </Box>
  )
}

export default EmergencyInformation
